import {
  LIST_CUSTOMER_FEEDBACK_URL,
  FEEDBACK_MESSAGES,
  SUBMIT_REPLY_URL
} from './constants'

/**
 * Get customer feedbacks
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/customer_feedbacks_controller.rb#L8
 * @param start, end, page
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getCustomerFeedbacks (queryparams) {
  return axios
    .get(LIST_CUSTOMER_FEEDBACK_URL, {params: queryparams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}

/**
 * Get customer feedback messages
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/customer_feedbacks_controller.rb#L43
 * @param ID feedback
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getFeedbackMessages (id, queryparams) {
  return axios
    .get(FEEDBACK_MESSAGES(id), {params: queryparams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}

/**
 * Send customer feedback to server
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/customer_feedbacks_controller.rb#L19
 * @param comment, feedback_id
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */

export function submitReply (data) {
  return axios
    .post(SUBMIT_REPLY_URL, data, {withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.response.data.message))
    })
}



// WEBPACK FOOTER //
// ./app/api/customer-feedbacks.js